<template>
  <!-- Overlay and Main modal -->
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 bg-black"
  >
    <div class="relative p-4 w-full max-w-md h-auto">
      <!-- Modal content -->
      <div
        class="relative p-4 text-centerrounded-lg shadow bg-gray-800 sm:p-5"
      >
        <button
          type="button"
          @click="closeModal"
          class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent  hover:text-gray-800 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center hover:bg-gray-600 "
        >
          <svg
            aria-hidden="true"
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <svg
          class="text-gray-500 w-11 h-11 mb-3.5 mx-auto"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clip-rule="evenodd"
          ></path>
        </svg>
        <p class="mb-4 text-gray-300">
          {{ deleteMessage }}
        </p>
        <div class="flex justify-center items-center space-x-4">
          <button
            @click="closeModal"
            type="button"
            class="py-2 px-3 text-sm font-medium rounded-lg border focus:ring-4 focus:outline-none focus:ring-primary-300 focus:z-10 bg-gray-700 text-gray-300 border-gray-500 hover:text-white hover:bg-gray-600 focus:ring-gray-600"
          >
            Cancelar
          </button>
          <button
            type="submit"
            @click="confirmDelete"
            class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg focus:ring-4 focus:outline-none bg-red-500 hover:bg-red-600 focus:ring-red-900"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    deleteMessage: {
      type: String,
      default: "Are you sure you want to delete this item?",
    },
  },
  methods: {
    openModal() {
      this.$emit("open");
    },
    closeModal() {
      this.$emit("close");
    },
    confirmDelete() {
      this.$emit("confirm");
    },
  },
};
</script>
